import { Component, type ErrorInfo, type ReactNode } from "react";

import { ErrorScreen } from "./ErrorScreen";

interface State {
  error: unknown;
  failed: boolean;
}

/**
 * The last line: an error thrown outside any route (a provider, the router
 * itself). Without it React unmounts everything and the page goes blank.
 */
export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null, failed: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, failed: true };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error(error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <ErrorScreen
        error={this.state.error}
        onRetry={() => {
          this.setState({ error: null, failed: false });
        }}
      />
    );
  }
}
